import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import type { FundingListItemVM, FundingListPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveFundings = createApiThunk<PaginatedResult<FundingListItemVM>, FundingListPaginationParams>(
  "fundings/retrieveFundings",
  async (params: FundingListPaginationParams, { extra: { adminRepository } }) => {
    return adminRepository!.adminGetFundingList(params);
  },
);
